// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbsStructuredData":"BreadcrumbsStructuredData_breadcrumbsStructuredData__hkDSI"};